/**
 * SettingsTabContent — Lazy-loaded wrapper for the booking settings tab, used
 * by the unified user-settings page (reached via top-right avatar → Settings).
 *
 * Preserves code-splitting so the settings panel is not pulled into the main
 * chunk on initial load.
 *
 * The content (SettingsPage) does NOT wrap in SettingsPanel — UserSettingsPage
 * owns the panel layout. This component is wired into createShell() via
 * `config.settings.additionalTabs` in App.tsx.
 *
 * Plan: web_shell_unified_settings_page_rollout_plan_2026-05-22.
 */

import { PageSkeleton } from "@plerity/dashboard-shared/components";
import { lazy, Suspense } from "react";

const SettingsPage = lazy(() => import("../booking/SettingsPage"));

function TabShell({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageSkeleton />}>{children}</Suspense>;
}

/** Booking Settings tab — injected as additionalTab into UserSettingsPage. */
export function BookingSettingsTabContent() {
  return (
    <TabShell>
      <SettingsPage />
    </TabShell>
  );
}
